import { cacheFirstConfig, http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { MaritalStatus } from './marital-status.interface';
export class MaritalStatusService {
   async getMaritalStatuses() {
      return await http
         .get<ApiResource<Array<MaritalStatus>>>(`/marital_statuses`, cacheFirstConfig)
         .then((response) => response.data.data);
   }
}
